//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import themeMixin from 'kolibri.coreVue.mixins.themeMixin';
import UiIcon from 'keen-ui/src/UiIcon';

export default {
  name: 'CoreMenuOption',
  components: {
    UiIcon,
  },
  mixins: [themeMixin],
  props: {
    type: String,
    label: String,
    link: String,
    secondaryText: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['showActive'],
  computed: {
    classes() {
      return {
        'is-divider': this.isDivider,
        'is-disabled': this.disabled,
        'is-active': this.active,
      };
    },
    isDivider() {
      return this.type === 'divider';
    },
    active() {
      let showActive = typeof this.showActive !== 'undefined' ? this.showActive : true;
      return showActive && window.location.pathname.startsWith(this.link);
    },
    optionStyle() {
      let color = '';
      if (!this.isDivider) {
        if (this.active) {
          color = this.$themeTokens.primary;
        } else if (this.disabled) {
          color = this.$themeTokens.annotation;
        } else {
          color = this.$themeTokens.text;
        }
      }
      const bg = {
        backgroundColor: this.$themeColors.palette.grey.v_200,
      };
      return Object.assign(
        {
          color,
        },
        this.disabled
          ? {}
          : {
              ':hover': bg,
            },
        {
          ":focus body[modality='keyboard']": bg,
        }
      );
    },
  },
  methods: {
    conditionalEmit() {
      if (!this.link) {
        this.$emit('select');
      }
    },
  },
};

